/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_Intro_Before_EmailInputs */

const tr_contact_form_intro_before_email = /** @type {(inputs: Contact_Form_Intro_Before_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hızlı yanıt için doğrudan kısa bir mesaj bırakabilirsin. Teknik bir konu varsa ekran görüntüsü eklemek yerine e-posta ile`)
};

const en_contact_form_intro_before_email = /** @type {(inputs: Contact_Form_Intro_Before_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can leave a quick message for a fast response. For technical issues, instead of adding a screenshot, use the email address `)
};

const de_contact_form_intro_before_email = /** @type {(inputs: Contact_Form_Intro_Before_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für eine schnelle Antwort können Sie direkt eine kurze Nachricht hinterlassen. Bei technischen Themen verwenden Sie bitte die E-Mail-Adresse `)
};

const ru_contact_form_intro_before_email = /** @type {(inputs: Contact_Form_Intro_Before_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы можете оставить короткое сообщение для быстрого ответа. По техническим вопросам используйте адрес электронной почты `)
};

/**
* | output |
* | --- |
* | "You can leave a quick message for a fast response. For technical issues, instead of adding a screenshot, use the email address" |
*
* @param {Contact_Form_Intro_Before_EmailInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const contact_form_intro_before_email = /** @type {((inputs?: Contact_Form_Intro_Before_EmailInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_Intro_Before_EmailInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_form_intro_before_email(inputs)
	if (locale === "de") return de_contact_form_intro_before_email(inputs)
	if (locale === "ru") return ru_contact_form_intro_before_email(inputs)
	return tr_contact_form_intro_before_email(inputs)
});